export const QUERY_KEYS = {
  PLAYER: 'player',
};
